<!-- eslint-disable tailwindcss/no-custom-classname -->
<!-- The use of "affirm-as-low-as" is required -->
<template>
  <div
    class="body-2 min-h-[42px] flex items-center"
    data-test="affirm-third-party-advertisement"
  >
    <p
      v-if="!hasError"
      class="affirm-as-low-as"
      :data-amount="purchaseAmount"
      :data-page-type="spot"
    ></p>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'

import { PaymentMethodCode } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import { priceToMinorUnits } from '@backmarket/utils/math/priceToMinorUnits'

import { usePaymentMethodsWithFallback } from '../../../methods'
import { useAffirmLibrary } from '../../composables/useAffirmLibrary'
import type { PaymentAdvertisingModalProps } from '../../types/PaymentAdvertisingModalProps'

const props = withDefaults(defineProps<PaymentAdvertisingModalProps>(), {
  name: 'AffirmThirdPartyAdvertisement',
  paymentMethods: null,
})

const paymentMethods = usePaymentMethodsWithFallback(() => props.paymentMethods)

const affirmPaymentMethod = computed(() => {
  const method = paymentMethods.value.find(
    ({ bmCode }) => bmCode === PaymentMethodCode.AFFIRM,
  )
  if (!method) {
    throw new Error('Could not find Affirm payment method')
  }

  return method
})

const hasError = ref(false)
const purchaseAmount = computed(() => priceToMinorUnits(props.basePrice))

const { onLoaded, onError } = useAffirmLibrary()
onError(() => {
  hasError.value = true
})

onMounted(() => {
  void affirmPaymentMethod.value

  const affirmWasAlreadyLoaded = window.affirm !== undefined

  onLoaded((lib) => {
    if (affirmWasAlreadyLoaded) {
      lib.ui.refresh()
    }
  })
})

watch(
  () => props.basePrice,
  () => {
    if (import.meta.client) {
      window.affirm?.ui?.refresh()
    }
  },
)
</script>
